const flipImageHorizontally = async (dataURL) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      // Flip horizontally
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);

      ctx.drawImage(img, 0, 0);

      resolve(canvas.toDataURL());
    };
    img.src = dataURL;
  });
};

export default flipImageHorizontally;
